ixModuleRouting("impactx.orderconfirmation", {
    "/orderconfirmationsupplierlist": {
        template: "<ixa-orderconfirmation-supplier-list></ixa-orderconfirmation-supplier-list>",
        templateUrl:
            "modules/orderconfirmation/templates/orderconfirmationsupplierlist.html",
        process: "ListOrderConfirmationSupplier",
        controller: "OrderConfirmationSupplierListCtrl",
        controllerAs: "orderConfirmationSupplierListCtrl",
        workspace: "shop",
    },
    "/orderconfirmationbuyerlist": {
        template: "<ixa-orderconfirmation-buyer-list></ixa-orderconfirmation-buyer-list>",
        templateUrl:
            "modules/orderconfirmation/templates/oderconfirmationbuyerlist.html",
        process: "ListOrderConfirmationBuyer",
        controller: "OrderConfirmationBuyerListCtrl",
        controllerAs: "orderConfirmationBuyerListCtrl",
        workspace: "shop",
    },
    "/orderconfirmationbuyer": {
        template: "<ixa-orderconfirmation-buyer></ixa-orderconfirmation-buyer>",
        templateUrl:
            "modules/orderconfirmation/templates/orderconfirmation.html",
        controller: "OrderConfirmationBuyerCtrl as orderConfirmationCtrl",
        process: "ViewOrderConfirmationBuyer",
        workspace: "shop",
    },
    "/orderconfirmationbuyer/:id": {
        template: "<ixa-orderconfirmation-buyer></ixa-orderconfirmation-buyer>",
        templateUrl:
            "modules/orderconfirmation/templates/orderconfirmation.html",
        controller: "OrderConfirmationBuyerCtrl as orderConfirmationCtrl",
        process: "ViewOrderConfirmationBuyer",
        workspace: "shop",
    },
    "/orderconfirmationsupplier": {
        template: "<ixa-orderconfirmation-supplier></ixa-orderconfirmation-supplier>",
        templateUrl:
            "modules/orderconfirmation/templates/orderconfirmation.html",
        controller: "OrderConfirmationSupplierCtrl as orderConfirmationCtrl",
        process: "ViewOrderConfirmationSupplier",
        workspace: "shop",
    },
    "/orderconfirmationsupplier/:id": {
        template: "<ixa-orderconfirmation-supplier></ixa-orderconfirmation-supplier>",
        templateUrl:
            "modules/orderconfirmation/templates/orderconfirmation.html",
        controller: "OrderConfirmationSupplierCtrl as orderConfirmationCtrl",
        process: "ViewOrderConfirmationSupplier",
        workspace: "shop",
    },
});
